import { Box, Flex, Image, Radio, RadioGroup, Text, useToast } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import RemitaPayment from "react-remita";
import { useNavigate, useParams, } from 'react-router-dom';
import purse from '../../../../img/purse.svg';
import remita from '../../../../img/remita.svg';
import { IAllCourse } from '../../../../models/allcourse.model';
import { IUser } from '../../../../models/auth.model';
import { ICourseEnrol } from '../../../../models/course-enrolment.model';
import routes from '../../../../pages/routes';
import { getLocalUserProfile } from '../../../../services/auth.service';
import courseEnrolmentService from '../../../../services/course-enrolment.service';
import paymentService from '../../../../services/payment.service';
import registrationService from '../../../../services/registration.service';


const SponsorVerifyPayment = ({ prePage, ...rest }: { prePage: any }) => {
    const navigate = useNavigate()
    const { course_id } = useParams();
    const [course, setCourse] = useState<IAllCourse>()
    const [user, setUser] = useState<IUser | null>()
    const [loading, setLoading] = useState(true);
    const toast = useToast();
    const [value, setValue] = useState('1')
    const [transactionid, setTransactionId] = useState(23)
    const [paymentData, setpaymentData] = useState({

    });

    useEffect(() => {
        const user = getLocalUserProfile();
       setUser(user)
        
        registrationService.getEachCourse(course_id)
            .then((response) => {
                setLoading(false)
                setCourse(response)
                if (user) {
                    const nameArray = user.name.split(' ')
                    setpaymentData(
                        {
                            key: 'QzAwMDAyNzEyNTl8MTEwNjE4NjF8OWZjOWYwNmMyZDk3MDRhYWM3YThiOThlNTNjZTE3ZjYxOTY5NDdmZWE1YzU3NDc0ZjE2ZDZjNTg1YWYxNWY3NWM4ZjMzNzZhNjNhZWZlOWQwNmJhNTFkMjIxYTRiMjYzZDkzNGQ3NTUxNDIxYWNlOGY4ZWEyODY3ZjlhNGUwYTY=',
                            customerId: `${user.email}`,
                            firstName: `${nameArray[0]}`,
                            lastName: `${nameArray[1]}`,
                            email: `${user.email}`,
                            amount: `${response.cost}`,
                            narration: `Payment for ${response.name.toLowerCase()}`,
                        }
                    )
                }

                setLoading(false)
                
            })
            .catch((err) => err)

    }, [])

    

    const data = {
        ...paymentData,
        onSuccess: function (response: any) {
            // function callback when payment is successful
            
            if (response)
                confirmPayment()
            


        },
        onError: function (response: any) {
            // function callback when payment fails
            
            if (response) {
                const confirm = {
                    payment_id: response.transactionId,
                    status: 'failed'
                }
                // paymentService.confirmPayment(confirm).then(
                //     (res) => {
                        
                //     }
                // );
            }

        },
        onClose: function () {
            // function callback when payment modal is closed
            
            
        },
    };
    const confirmPayment = () => {
     const paymentid = localStorage.getItem('paymentId')
     
            if(paymentid){
                const confirm = {
                    payment_id: paymentid.toString(),
                    status: 'confirmed'
                }
                paymentService.confirmPayment(confirm).then(
                    (res) => {
                        if(res.message =="Payment confirmed successfully"){
                            navigate(routes.successfulPayment)
                            enrolCourse(res.data.id)
                        }
                          
                    }
                );     
            }
    }
    const enrolCourse = (paymentId: number) => {
    //     \"centre_1_id\": \"1\",
    // \"centre_2_id\": \"1\",
    // \"payment_mode\": \"Full\",
    // \"sponsor_id\": \"1\",
    // \"payment_ids\": \"1,2,3\",
    // \"enrolled_by\": \"1\"
        if (course){
            const enrolCourseData : ICourseEnrol= {
               
                centre_1_id:'1',
                payment_ids:paymentId.toString(),
                payment_mode:'Full',
                enrolled_by: user?.id.toString(),
                course_session_id:'1',
                course_term_id:'1'

    
            }
            
            courseEnrolmentService.enrolCourse(enrolCourseData,course.uuid).then(
                (res) => {
                    console.log(res)
                }
            )
        }
       
    }
        const initiatepayment = () => {
            const data = {
                type: 'course',
                amount: `${course?.cost}`,
                processor: 'remita'
            }
            paymentService.inititatePayment(data).then(
                (res) => {
                    
                    
                    localStorage.setItem('paymentId', res.data.id)
                   // setTransactionId(res.data.id)
                }
            );

        }

    

    return (
        <Box px={6} mb='50px' >
            <Flex justifyContent='center' mt='60px' mb='35px'>
                <Text mx='auto' color='#616161' fontSize='20px' fontWeight='700'>Confirm Payment</Text>
            </Flex>

            <Box py='8px' borderRadius='8px' boxShadow='base'>
                <Flex justifyContent='space-between' pt='25px' pb='15px' px='30' borderBottom='1px solid' borderColor='lightgray'>
                    <Text>
                        Training Program
                    </Text>
                    <Text textTransform='capitalize'>{course?.name.toLowerCase()}</Text>
                </Flex>
                <Flex justifyContent='space-between' pt='25px' pb='15px' px='30' borderBottom='1px solid' borderColor='lightgray'>
                    <Text>
                        Total Transaction Amount (NGN):
                    </Text>
                    <Text>{course?.cost}</Text>
                </Flex>
                <Flex justifyContent='space-between' pt='25px' pb='15px' px='30'>
                    <Text>
                        Allowed Number of Installment :
                    </Text>
                    <Text>{course?.installment}</Text>
                </Flex>

            </Box>
            <Box py='8px' borderRadius='8px' boxShadow='base'>
                <Flex pt='25px' pb='15px' px='30' >
                    <Text>Select Payment Method</Text>
                </Flex>
                <RadioGroup onChange={setValue} value={value}>
                    <Flex justifyContent='space-between' pt='25px' pb='15px' px='30' >
                        <Radio colorScheme='red' value='1'>Walconst (Balance: N230,0000)</Radio>
                        <Image width='80px' height='20px' src={purse} />
                    </Flex>
                    <Flex justifyContent='space-between' pt='25px' pb='15px' px='30' >
                        <Radio colorScheme='red' value='2'>Remita Web Pay</Radio>
                        <Image src={remita} />
                    </Flex>
                </RadioGroup>


            </Box>
            <Box width='200px' mx='auto' >
                <Flex justifyContent='center' flexDirection='column'>
                    <Text mx='auto' pt='30px' pb='20px' fontSize='14px' color='#616161'>Supported Options</Text>
                    <Box mx='auto' >   <Image src={remita} /></Box>
                    <Box pl='30px' onClick={() => { initiatepayment() }} mt='20px'>
                        <RemitaPayment
                            remitaData={data}
                            className='btn' // class to style the button
                            text='PAY NOW' //text to show on button
                        // add a 'live' prop to use the live urls/keys
                        />
                    </Box>
                    {/* <Box mx='auto' >   <Button mt='20px' py='13px' px='30px' type="submit" fontSize={11} borderRadius={0} colorScheme='red' size='sm'>PAY NOW</Button>
                    </Box> */}
                </Flex>
            </Box>


        </Box>
    );



}

export default SponsorVerifyPayment;